/** Short, bounded tones; callers must unlock audio from a user gesture. */
export function playTopupChime(audio: AudioContext, ringCount: number): void {
    if (audio.state !== 'running') return;
    const count = Number.isFinite(ringCount) ? Math.min(3, Math.max(1, Math.floor(ringCount))) : 3;
    for (let i = 0; i < count; i++) {
        const oscillator = audio.createOscillator(), gain = audio.createGain();
        const start = audio.currentTime + i * 0.65;
        oscillator.frequency.value = 880; oscillator.connect(gain); gain.connect(audio.destination);
        gain.gain.setValueAtTime(0, start); gain.gain.linearRampToValueAtTime(0.12, start + 0.02);
        gain.gain.exponentialRampToValueAtTime(0.001, start + 0.4);
        oscillator.start(start); oscillator.stop(start + 0.45);
    }
}
/** Call under a cross-tab Web Lock. Separate channels prevent new/reminder keys replacing one another. */
export function claimTopupAttention(storage: Pick<Storage, 'getItem' | 'setItem'>, scope: string, key: string): boolean {
    const name = 'topup-alert:' + scope + ':' + key.split(':')[0];
    if (!scope || !key || storage.getItem(name) === key) return false;
    storage.setItem(name, key);
    return true;
}
